<template>
    <v-btn icon fab small primary="transparent" class="elevation-0" :loading='loading' :disabled='loading' @click.stop='deletePolicyHandler'>
        <v-icon medium>mdi-delete-forever</v-icon>
    </v-btn>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'DeletePolicyButton',
        props: ['policyData'],
        data () {
            return {
                loading: false
            }
        },
        methods: {
            ...mapActions(['deletePolicy']),
            async deletePolicyHandler () {
                const confirm = await this.$root.$confirmDialog.open(this.policyData.name)
                if (!confirm) {
                    return
                }
                this.initDeletePolicy()
            },
            async initDeletePolicy () {
                try {
                    this.loading = true
                    await this.deletePolicy(this.policyData.id)
                    this.$emit('updatePolicyList')
                    this.loading = false
                } catch (e) {
                    this.loading = false
                }
            }
        }
    }
</script>
